module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crowd-container"
  }, [_c('div', {
    staticClass: "crowd-content form"
  }, [_c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCrowd),
      expression: "newCrowd"
    }],
    ref: "crowdForm",
    attrs: {
      "before-submit": _vm.preventSubmit
    },
    domProps: {
      "value": (_vm.newCrowd)
    },
    on: {
      "input": function($event) {
        _vm.newCrowd = $event
      }
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人群名称：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCrowd.name),
      expression: "newCrowd.name"
    }],
    class: {
      'error': !_vm.isNameValid
    },
    attrs: {
      "name": "name",
      "disabled": _vm.isDisabled,
      "rules": _vm.rules.name,
      "placeholder": "请输入1-20字符名称"
    },
    domProps: {
      "value": (_vm.newCrowd.name)
    },
    on: {
      "focus": function($event) {
        _vm.isNameValid = true
      },
      "input": function($event) {
        _vm.newCrowd.name = $event
      }
    }
  })], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("人群定义：")]), _c('div', {
    staticClass: "control-tool"
  }, [_c('timeSpan', {
    attrs: {
      "noCommitState": _vm.noCommitState,
      "filters": "7a"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('p', {
    staticClass: "crowd-data"
  }, [_c('span', [_vm._v("用户数约：")]), (!_vm.crowdDataLoading) ? _c('span', {
    staticClass: "crowd-num"
  }, [_vm._v(_vm._s(_vm.crowdNum))]) : _c('span', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://p4.ssl.qhimg.com/t019c427ceb6ab4efec.gif"
    }
  })]), _c('span', [_vm._v("用户占比：")]), (!_vm.crowdDataLoading) ? _c('span', {
    staticClass: "crowd-percent"
  }, [_vm._v(_vm._s(_vm.crowdPercent))]) : _c('span', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": "https://p4.ssl.qhimg.com/t019c427ceb6ab4efec.gif"
    }
  })])])], 1), _c('div', {
    staticClass: "control-wrap",
    class: {
      'no-scroll': _vm.noscroll
    },
    on: {
      "mousewheel": function($event) {
        _vm.onMousewheel($event)
      }
    }
  }, [(_vm.newCrowd.attr_rule.length == 0 && !_vm.isDisabled) ? _c('p', {
    staticClass: "opt-add",
    on: {
      "click": _vm.addNewAttr
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-mgr"
  }), _vm._v("添加人群属性")]) : (_vm.newCrowd.attr_rule.length > 0) ? _c('p', {
    staticClass: "attr-list"
  }, [_vm._v("人群属性")]) : _vm._e(), _vm._l((_vm.newCrowd.attr_rule), function(attrItem, index) {
    return _c('p', {
      staticClass: "attr-item"
    }, [_c('Cascader', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attrItem.d),
        expression: "attrItem.d"
      }],
      attrs: {
        "placeholder": "请选择条件",
        "menu": _vm.attrDims,
        "size": "big",
        "valid": attrItem.d_valid,
        "disabled": _vm.isDisabled,
        "showkey": "title"
      },
      domProps: {
        "value": (attrItem.d)
      },
      on: {
        "input": [function($event) {
          attrItem.d = $event
        }, function($event) {
          _vm.changeDim(attrItem)
        }]
      }
    }), _c('v-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attrItem.d_r),
        expression: "attrItem.d_r"
      }],
      attrs: {
        "options": _vm.drRelationships,
        "disabled": _vm.isDisabled
      },
      domProps: {
        "value": (attrItem.d_r)
      },
      on: {
        "input": [function($event) {
          attrItem.d_r = $event
        }, function($event) {
          _vm.attrDvChange(attrItem)
        }]
      }
    }), _c('MutilSelect', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (attrItem.d_v),
        expression: "attrItem.d_v"
      }],
      attrs: {
        "valid": attrItem.v_valid,
        "placeholder": _vm.getPlaceholder(_vm.attrDims, attrItem),
        "api": "/api/crowd/getDimValue",
        "isSearched": _vm.checkSearchable(_vm.attrDims, attrItem.d),
        "dim": _vm.getAttrActionDim(_vm.attrDims, attrItem.d),
        "maxlength": _vm.maxRuleNum,
        "disabled": _vm.isDisabled
      },
      domProps: {
        "value": (attrItem.d_v)
      },
      on: {
        "input": [function($event) {
          attrItem.d_v = $event
        }, function($event) {
          _vm.setCurrentItem(attrItem)
        }],
        "change": _vm.dvChange
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isDisabled),
        expression: "!isDisabled"
      }],
      staticClass: "fa fa-trash-o fa-lg fa-mgr",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.removeAttrItem(index)
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isDisabled && _vm.isMaxLength(index, _vm.newCrowd.attr_rule)),
        expression: "!isDisabled && isMaxLength(index, newCrowd.attr_rule)"
      }],
      staticClass: "fa fa-plus-circle fa-lg",
      attrs: {
        "title": "添加"
      },
      on: {
        "click": _vm.addNewAttr
      }
    })], 1)
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newCrowd.attr_rule.length > 1),
      expression: "newCrowd.attr_rule.length > 1"
    }],
    staticClass: "attr-item"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCrowd.attr_calc),
      expression: "newCrowd.attr_calc"
    }],
    attrs: {
      "disabled": _vm.isDisabled,
      "options": _vm.calcRelations
    },
    domProps: {
      "value": (_vm.newCrowd.attr_calc)
    },
    on: {
      "input": [function($event) {
        _vm.newCrowd.attr_calc = $event
      }, function($event) {
        _vm.getEstimate()
      }]
    }
  })], 1), _c('p'), (!_vm.isDisabled && _vm.newCrowd.action_rule.length == 0) ? _c('p', {
    staticClass: "opt-add",
    on: {
      "click": _vm.addNewAction
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-mgr"
  }), _vm._v("添加用户行为")]) : (_vm.newCrowd.action_rule.length > 0) ? _c('p', {
    staticClass: "action-list"
  }, [_vm._v("用户行为")]) : _vm._e(), _vm._l((_vm.newCrowd.action_rule), function(actionItem, index) {
    return _c('p', {
      staticClass: "action-item"
    }, [_c('Cascader', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.d),
        expression: "actionItem.d"
      }],
      attrs: {
        "placeholder": "请选择条件",
        "menu": _vm.actionDims,
        "valid": actionItem.d_valid,
        "size": "small",
        "disabled": _vm.isDisabled,
        "showkey": "title"
      },
      domProps: {
        "value": (actionItem.d)
      },
      on: {
        "input": [function($event) {
          actionItem.d = $event
        }, function($event) {
          _vm.changeDim(actionItem)
        }]
      }
    }), _c('MutilSelect', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.d_v),
        expression: "actionItem.d_v"
      }, {
        name: "show",
        rawName: "v-show",
        value: (_vm.checkDvShow(actionItem.d)),
        expression: "checkDvShow(actionItem.d)"
      }],
      attrs: {
        "api": "/api/crowd/getDimValue",
        "valid": actionItem.v_valid,
        "placeholder": _vm.getPlaceholder(_vm.actionDims, actionItem),
        "isSearched": _vm.checkSearchable(_vm.actionDims, actionItem.d),
        "dim": _vm.getAttrActionDim(_vm.actionDims, actionItem.d),
        "maxlength": _vm.maxRuleNum,
        "inputPattern": _vm.urlPattern(actionItem),
        "disabled": _vm.isDisabled
      },
      domProps: {
        "value": (actionItem.d_v)
      },
      on: {
        "input": [function($event) {
          actionItem.d_v = $event
        }, function($event) {
          _vm.setCurrentItem(actionItem)
        }],
        "change": _vm.dvChange
      }
    }), _c('v-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.m_r),
        expression: "actionItem.m_r"
      }],
      attrs: {
        "disabled": _vm.isDisabled,
        "options": _vm.mrRelationships
      },
      domProps: {
        "value": (actionItem.m_r)
      },
      on: {
        "input": [function($event) {
          actionItem.m_r = $event
        }, function($event) {
          _vm.mvChange(actionItem)
        }]
      }
    }), (actionItem.d === 'atime') ? _c('span', {
      staticClass: "atime"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.minutes),
        expression: "actionItem.minutes"
      }],
      staticClass: "size-mini",
      attrs: {
        "autocomplete": "off",
        "type": "number"
      },
      domProps: {
        "value": _vm._s(actionItem.minutes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          actionItem.minutes = _vm._n($event.target.value)
        }, function($event) {
          _vm.calcTime(actionItem)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v("分"), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.seconds),
        expression: "actionItem.seconds"
      }],
      staticClass: "size-mini",
      class: {
        'error': actionItem.s_valid
      },
      attrs: {
        "autocomplete": "off",
        "type": "number"
      },
      domProps: {
        "value": _vm._s(actionItem.seconds)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          actionItem.seconds = _vm._n($event.target.value)
        }, function($event) {
          _vm.calcTime(actionItem)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v("秒")]) : _vm._e(), (actionItem.d !== 'atime') ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (actionItem.m_v),
        expression: "actionItem.m_v"
      }],
      staticClass: "size-small",
      class: {
        'error': actionItem.m_valid
      },
      attrs: {
        "name": "name",
        "autocomplete": "off",
        "min": "0",
        "type": "number",
        "disabled": _vm.isDisabled,
        "placeholder": _vm.mvPlaceholder(actionItem)
      },
      domProps: {
        "value": _vm._s(actionItem.m_v)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          actionItem.m_v = _vm._n($event.target.value)
        }, function($event) {
          _vm.numberChange(actionItem)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isDisabled),
        expression: "!isDisabled"
      }],
      staticClass: "fa fa-trash-o fa-lg fa-mgr",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.removeActionItem(index)
        }
      }
    }), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isDisabled && _vm.isMaxLength(index, _vm.newCrowd.action_rule)),
        expression: "!isDisabled && isMaxLength(index, newCrowd.action_rule)"
      }],
      staticClass: "fa fa-plus-circle fa-lg",
      attrs: {
        "title": "添加"
      },
      on: {
        "click": _vm.addNewAction
      }
    })], 1)
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newCrowd.action_rule.length > 1),
      expression: "newCrowd.action_rule.length > 1"
    }],
    staticClass: "attr-item"
  }, [_c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCrowd.action_calc),
      expression: "newCrowd.action_calc"
    }],
    attrs: {
      "options": _vm.calcRelations
    },
    domProps: {
      "value": (_vm.newCrowd.action_calc)
    },
    on: {
      "input": [function($event) {
        _vm.newCrowd.action_calc = $event
      }, function($event) {
        _vm.getEstimate()
      }]
    }
  })], 1), _c('p')], 2)])])], 1), _c('div', {
    staticClass: "crowd-footer"
  }, [_vm._t("btnwraper", null, {
    crowd: _vm.newCrowd
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-abe5638e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abe5638e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/crowdTemplate.vue
// module id = 787
// module chunks = 0